module.exports = __webpack_public_path__ + "static/swing-6478805d26f8829f3f8c95c0d805dc89.jpg";